'use client';

import { useContext } from 'react';
import { DictionaryContext } from '@/contexts/dictionary-context';
import { Dictionary } from '@/types';

export function useTranslations(namespace?: string) {
  const dictionary = useContext(DictionaryContext);

  if (!dictionary) {
    throw new Error('useTranslations must be used within a DictionaryProvider');
  }

  // Helper function to get nested values using dot notation
  const getValue = (obj: Dictionary, path: string): string => {
    return path.split('.').reduce((current: unknown, key: string): unknown => {
      if (current && typeof current === 'object' && key in current) {
        return (current as Dictionary)[key];
      }
      return path;
    }, obj) as string;
  };

  return (key: string, params?: Record<string, string | number>) => {
    const fullKey = namespace ? `${namespace}.${key}` : key;
    let value = getValue(dictionary, fullKey);

    // Handle interpolation if params are provided
    if (params && typeof value === 'string') {
      Object.entries(params).forEach(([param, val]) => {
        value = value.replace(`{${param}}`, String(val));
      });
    }

    return typeof value === 'string' ? value : fullKey;
  };
}
